import getRemBase from 'propel/getRemBase';

const setHeaderHeight = () => {
	const header = document.querySelector('.main-header');
	const adminBar = document.getElementById('wpadminbar');
	const quickLinks = document.querySelector('.block-quick-links');

	const headerHeight = header ? header.offsetHeight : 0;
	const adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
	const quickLinksHeight = quickLinks ? quickLinks.offsetHeight : 0;

	document.body.style.setProperty(
		'--header-height',
		`${(headerHeight + adminBarHeight + quickLinksHeight - 1) / getRemBase()}rem`
	);
};

export default setHeaderHeight;
